// Replace with real, verifiable customer testimonials and their photo URLs.
export type Testimonial = {
  name: string;
  country: string;
  flag: string;
  photo: string;
  quote: string;
};

export const testimonials: Testimonial[] = [
  { name: "[Real Customer Name]", country: "United States", flag: "🇺🇸", photo: "", quote: "[Real testimonial about how the Blueprint helped organize their practice.]" },
  { name: "[Real Customer Name]", country: "United Kingdom", flag: "🇬🇧", photo: "", quote: "[Real testimonial about the visual reference system.]" },
  { name: "[Real Customer Name]", country: "Canada", flag: "🇨🇦", photo: "", quote: "[Real testimonial about the practice planner or checklists.]" },
  { name: "[Real Customer Name]", country: "Australia", flag: "🇦🇺", photo: "", quote: "[Real testimonial about using the system during practice.]" },
  { name: "[Real Customer Name]", country: "United States", flag: "🇺🇸", photo: "", quote: "[Real testimonial about the difference between having scattered PDFs and having an organized system.]" },
];
